var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesert4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 60,
    viewBox: "0 0 128 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27073 31.5274L4.33662 28.258C2.68761 22.4865 5.18554 16.3342 10.3912 13.3457L21.2261 7.12571C24.2514 5.38897 27.6615 4.43274 31.1487 4.34333L50.037 3.85901C54.9431 3.73321 58.5495 8.42297 57.1681 13.1323L57.0518 13.5289C53.7618 24.7448 65.7214 34.3027 75.9313 28.6367L89.9914 21.1931C91.7331 20.2711 93.5707 19.543 95.4712 19.0219L109.212 15.2543C115.515 13.526 122.056 17.0938 124.016 23.3291C124.607 25.2097 124.732 27.206 124.379 29.1456L124.016 31.1395C122.93 37.1137 119.233 42.2909 113.936 45.2577L113.693 45.3936C112.149 46.2583 110.501 46.9239 108.79 47.3743L78.009 55.4744C76.4534 55.8838 74.7989 55.4008 73.7078 54.2189C71.106 51.4002 67.1584 50.2521 63.4508 51.2358L45.4293 56.017C44.2208 56.3376 42.9757 56.5 41.7253 56.5H24.2354C21.5333 56.5 19.7759 53.6564 20.9843 51.2396C23.7409 45.7264 20.6833 39.0785 14.7034 37.5835L10.4267 36.5143C7.94039 35.8928 5.97479 33.9916 5.27073 31.5274Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesert4);
export default __webpack_public_path__ + "static/media/desert4.2feab546.svg";
export { ForwardRef as ReactComponent };